export function saveByteArray(reportName, blob) {
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  const fileName = reportName;
  link.download = fileName;
  link.click();
}

export const b64toBlob = async (base64, type = 'application/octet-stream') => {
  const res = await fetch(`data:${type};base64,${base64}`);
  return await res.blob();
}


// WEBPACK FOOTER //
// ./src/util/saveByteArray.ts